<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="listOptions"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="documentsState.loading"
          :style="{ opacity: documentsState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay documentos para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('List', [
      'documentsState'
    ]),
    optionSelected() {
      return this.documentsState.list.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.documentsState.list.length
        || this.documentsState.loading;
    },
    listOptions() {
      if (!this.parentValue) {
        return [];
      }
      if (this.typeNumeration === 'numOf') {
        return this.documentsState.list
          .filter((group) => group.extra.numOf);
      }
      if (this.typeNumeration === 'numInt') {
        return this.documentsState.list
          .filter((group) => group.extra.numInt);
      }
      if (this.typeNumeration === 'interno' || this.typeNumeration === 'externo') {
        return this.documentsState.list
          .filter((document) => (!document.extra.numInt && !document.extra.numOf));
      }

      return this.documentsState.list;
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchDocuments'
    ]),
    onInput(event) {
      this.$emit('input', event?.value);
      this.$emit('input-option', event);
    },
    getOption() {
      return this.documentsState.list.find((option) => option.value === this.value);
    }
  },
  created() {
    if (this.nested) {
      // TODO: this.clearDocuments();
      this.$watch('parentValue', (newValue, oldValue) => {
        if (newValue !== oldValue) {
          if (oldValue !== '') {
            this.$emit('input', '');
          }
          this.fetchDocuments(newValue);
        }
      });

      if (this.parentValue) {
        this.fetchDocuments(this.parentValue);
      }
    } else {
      this.fetchDocuments(this.parentValue);
    }
  },
  props: {
    name: { type: String, required: true },
    label: { type: String, default: 'Documentos' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    nested: { type: Boolean, default: true },
    parentValue: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    typeNumeration: { type: String }
  }
};

</script>
